import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { createTask } from '../api';

export function NewTask() {
  const navigate = useNavigate();
  const [phone, setPhone] = useState('');
  const [instruction, setInstruction] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const task = await createTask({ phoneNumber: phone.trim(), instruction: instruction.trim() });
      navigate(`/tasks/${task.id}`);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to place call');
      setSubmitting(false);
    }
  }

  const ready = phone.trim().length > 4 && instruction.trim().length > 5;

  return (
    <div className="main-inner">
      <header className="page-header">
        <div className="eyebrow">New call</div>
        <h1 className="page-title">
          Dispatch <em>the operator.</em>
        </h1>
        <p className="page-subtitle">
          Hand off a phone task — a reservation, a question, a status check — and
          the agent will place the call, hold the conversation, and report back.
        </p>
      </header>

      <form className="form" onSubmit={submit}>
        <div className="field">
          <label className="field-label" htmlFor="phone">
            <span className="field-label-num">1</span>
            Phone number
          </label>
          <input
            id="phone"
            className="input input-mono"
            type="tel"
            placeholder="+1 555 0100"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            autoFocus
            inputMode="tel"
            spellCheck={false}
          />
        </div>

        <div className="field">
          <label className="field-label" htmlFor="instruction">
            <span className="field-label-num">2</span>
            Task
          </label>
          <textarea
            id="instruction"
            className="textarea"
            placeholder="Call Bocca and ask if they have a table for four at seven thirty tonight; if yes, book it under Riley."
            value={instruction}
            onChange={(e) => setInstruction(e.target.value)}
            rows={3}
          />
        </div>

        {error && <div className="form-error">{error}</div>}

        <div className="submit-row">
          <div className="submit-hint">
            E.164 format, please — country code first.
          </div>
          <button className="btn-primary" type="submit" disabled={!ready || submitting}>
            {submitting ? <span className="spinner" /> : null}
            {submitting ? 'Placing call' : 'Place call →'}
          </button>
        </div>
      </form>
    </div>
  );
}
